export default __webpack_public_path__ + "static/media/API_Permissions.5dce10cc.png";